import "@babel/polyfill";
import Vue from "vue";
import "./interceptor";
import "./filter";
import "./mixin";
import "./global_components";
import "roboto-fontface/css/roboto/roboto-fontface.css";

import "./assets/sass/variables.scss";

// import plugin
import "./plugins";
import { DSN_SENTRY } from "@/const";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

Vue.use(Datetime);
import { Settings } from "luxon";
//set to display dates for English language
Settings.defaultLocale = "id";

import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
Vue.use(wysiwyg, {
  hideModules: { image: true }
});

import device from "vue-device-detector-js";
Vue.use(device);

// integrasi sentry
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

Sentry.init({
  dsn: DSN_SENTRY,
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: true
    })
  ]
});

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
